import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'ar', name: 'العربية', flag: '🇦🇪' }
];

const LanguageSwitcher = ({ variant = 'default', className = '' }) => {
  const { i18n } = useTranslation();

  const currentLang = i18n.language?.split('-')[0] || 'en';
  const currentLanguage = languages.find(lang => lang.code === currentLang) || languages[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  // Compact variant for mobile/navbar
  if (variant === 'compact') {
    return (
      <Select value={currentLang} onValueChange={changeLanguage}>
        <SelectTrigger className={`w-auto min-w-[70px] h-9 px-2 bg-white border-gray-200 ${className}`}>
          <span className="flex items-center gap-1">
            <span className="text-base">{currentLanguage.flag}</span>
            <span className="text-xs font-medium hidden sm:inline">{currentLanguage.code.toUpperCase()}</span>
          </span>
        </SelectTrigger>
        <SelectContent>
          {languages.map(lang => (
            <SelectItem key={lang.code} value={lang.code}>
              <span className="flex items-center gap-2">
                <span className="text-base">{lang.flag}</span>
                <span className="text-sm">{lang.name}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  // Default full variant
  return (
    <Select value={currentLang} onValueChange={changeLanguage}>
      <SelectTrigger className={`w-[140px] bg-white border-gray-200 ${className}`}>
        <span className="flex items-center gap-2">
          <Globe className="h-4 w-4 text-gray-500" />
          <span className="text-base">{currentLanguage.flag}</span>
          <span className="text-sm">{currentLanguage.name}</span>
        </span>
      </SelectTrigger>
      <SelectContent>
        {languages.map(lang => (
          <SelectItem key={lang.code} value={lang.code}>
            <span className="flex items-center gap-2">
              <span className="text-base">{lang.flag}</span>
              <span className="text-sm">{lang.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSwitcher;
